export enum ResourceVisibilityFilter {
  All = 1,
  Public,
  Private,
}
